import AbstractProductType from './AbstractProductType'
import { ProductTypeFormat } from './types'

export default class ValetRooftopOversized extends AbstractProductType {

  name = 'valet_rooftop_oversized'
  title = 'Valet Rooftop Oversized'

  oversized = true
  valet = true

  format = ProductTypeFormat.Rooftop

}
